import { render, staticRenderFns } from "./EditCouponRuleCpps.vue?vue&type=template&id=67273a98&scoped=true"
import script from "./EditCouponRuleCpps.vue?vue&type=script&lang=js"
export * from "./EditCouponRuleCpps.vue?vue&type=script&lang=js"
import style0 from "./EditCouponRuleCpps.vue?vue&type=style&index=0&id=67273a98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67273a98",
  null
  
)

export default component.exports